import React from "react";

import { getPopupNofify } from "../../model/profile";
import HtmlToReactParser from "html-to-react";
import { Modal } from "react-bootstrap";

const DetailAdsBox = (props) => {
	const { isShow } = props;
	const htmlToReactParser = new HtmlToReactParser.Parser();
	const content = htmlToReactParser.parse(props.content);

	return (
		<Modal show={isShow} onHide={props.hide} dialogClassName="modal-m modal-dialog notify-container-fluid">
			<Modal.Header closeButton={true} closeLabel={""} />
			<Modal.Body>{content}</Modal.Body>
		</Modal>
	);
};

class AdsPromos extends React.Component {
	constructor() {
		super();
		this.state = {
			isShowDetailAdsBox: false,
			messageAds: "",
		};
	}

	componentDidMount() {
		this.swiper = new window.Swiper(this.refs.swiperAdBanner, {
			slidesPerView: 1.4,
			spaceBetween: 10,
			threshold: 10,
			speed: 600,
			navigation: {
				nextEl: ".next-ads",
				prevEl: ".prev-ads",
			},
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			breakpoints: {
				992: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2.5,
					spaceBetween: 10,
				},
				481: {
					slidesPerView: 2,
				},
			},
		});
	}

	showDetailAdsBox = (popupNotifId) => {
		getPopupNofify(popupNotifId).then((popupNotifyResp) => {
			if (popupNotifyResp.data.error === 0) {
				this.setState({
					isShowDetailAdsBox: true,
					messageAds: popupNotifyResp.data.data.notification.content,
				});
			}
		});
	};

	hideDetailAdsBox = () => {
		this.setState({
			isShowDetailAdsBox: false,
		});
	};

	render() {
		const { isShowDetailAdsBox, messageAds } = this.state;
		const { adsPromos } = this.props;
		return (
			<div className="promo-section space sec">
				<div className="m-container">
					<h2>Chương Trình Khuyến&nbsp;Mãi</h2>
					<h5 className="title">Nhận nhiều ưu đãi hấp dẫn từ&nbsp;Mioto</h5>
				</div>
				<div className="m-container">
					<div ref="swiperAdBanner" className="swiper swiper-promo">
						<div className="swiper-wrapper">
							{adsPromos &&
								adsPromos.map((adsPromo, i) => (
									<div className="swiper-slide" key={i}>
										<div className="fix-img" onClick={() => this.showDetailAdsBox(adsPromo.popupNotifId)}>
											<img loading="lazy" src={adsPromo.coverUrlV2} />
										</div>
										{/* {adsPromo.desc !== "" && <p>
											{adsPromo.desc}
										</p>} */}
									</div>
								))}
						</div>
					</div>
					<div className="swiper-button-prev prev-ads" />
					<div className="swiper-button-next next-ads" />
					{isShowDetailAdsBox && (
						<DetailAdsBox isShow={isShowDetailAdsBox} content={messageAds} hide={this.hideDetailAdsBox} />
					)}
				</div>
			</div>
		);

		// return <div className="promo__sect">
		// <div className="m-container">
		// 	<h3 className="title-car">Ưu đãi hiện hành</h3>
		// 	<div className="swiper-button-next next-bn"><i className="i-arr" /></div>
		// 	<div className="swiper-button-prev prev-bn"><i className="i-arr" /></div>
		// 		<div ref="swiperAdBanner" className="swiper swiper-banner banner-promo__wrap">
		// 		<div className="swiper-wrapper">
		// 			{adsPromos && adsPromos.map((adsPromo, i) => <div className="swiper-slide" key={i} >
		// 				<div className="fix-img" onClick={() => this.showDetailAdsBox(adsPromo.popupNotifId)}	> <img src={adsPromo.coverUrl} /></div>
		// 			</div>)}
		// 		</div>
		// 		{isShowDetailAdsBox && <DetailAdsBox isShow={isShowDetailAdsBox} content={messageAds} hide={this.hideDetailAdsBox} />}
		// 		</div>
		// 	</div>
		// </div>
	}
}

export default AdsPromos;
